<template>
<!-- id="iue-chart" need for backand report builder. Don't delete!  -->
<div class="m-0 p-0 mt-1" id="iue-chart">
	<pick-period-vidget
		:defaultTileIndex="urlParamCheckedPeriodIndex ? urlParamCheckedPeriodIndex : 0"
		@currentTile="(tile, index) => {
			setUrlParms({
				time_from: new Date(
						(urlParamTimeTo == undefined ? new Date() : urlParamTimeTo).getTime()
						- (tile[1] * 24 * 3600 * 1000)
					).toISOString(),
				checked_period_index: index
			});
		}"
	/>

	<div
		class="half-transparent-border full-width-widget m-0 p-0 mt-1"
		:style="{ height: chartHeight + 'px', }"
	>
		<station-voltage-curent-potential-chart
			:stationId="stationId"
			:time-from="iueChartTimeFrom"
			:time-to="iueChartTimeTo"
			:is-data-zoom="isDataZoom"
			:isExpandable="true"
			:is-expand="true"
			@collapse="$router.push({
				name: 'station_control',
				params: { stationId },
				query: $route.query,
			})"
		/>
	</div>
</div>
</template>




<script>
import StationVoltageCurentPotentialChart from '@/components/Charts/StationVoltageCurentPotentialChart.vue'
import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'

export default {
	inject: ['headerHeight'],

	components: {
		StationVoltageCurentPotentialChart,
		PickPeriodVidget,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
		// timeFrom: {
		// 	type: Date,
		// 	require: false,
		// 	default: () => {
		// 		const now = new Date()
		// 		now.setDate(now.getDate() - 1)
		// 		//now.setHours(now.getHours() - 4)
		// 		return now
		// 	},
		// },
		// timeTo: {
		// 	type: Date,
		// 	require: false,
		// 	default: new Date(),
		// },
		// isDataZoom: {
		// 	type: Boolean,
		// 	require: false,
		// 	default: true,
		// },
	},

	setup() {
		return {}
	},

	data() {
		return {}
	},

	created() {},

	methods: {
		setUrlParms(parms) {
			const query = { ...this.$route.query }

			this.$router.replace({
				name: this.$route.name,
				params: this.$route.params,
				query: Object.assign(query, parms),
			})
		},
	},

	computed: {
		chartHeight() {
			const	body = document.body,
					html = document.documentElement;
			const	docHeight = Math.max(body.scrollHeight, body.offsetHeight, 
					html.clientHeight, html.scrollHeight, html.offsetHeight);
			const chartHeight = docHeight - Number(this.headerHeight.replace(/[^0-9]/gi, '')) - 120
			
			return chartHeight
		},

		iueChartTimeFrom() {
			if (this.$route.query?.time_from) {
				return new Date(this.$route.query.time_from)
			} else {
				return undefined
			}
		},

		iueChartTimeTo() {
			if (this.$route.query?.time_to) {
				return  new Date(this.$route.query?.time_to)
			} else {
				return undefined
			}
		},

		isDataZoom() {
			return this.$route.query.is_data_zoom != 'false'
		},

		urlParamCheckedPeriodIndex() {
			return this.$route.query.checked_period_index
		},
	},
}
</script>




<style src="@/assets/widget.css" scoped></style>